// 이메일 인증

import { useMutation } from "@tanstack/react-query";
import { resetPwdAuthApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useAlertStore from "store/alert";

export const useAuthEmailMutate = () => {
  const { t } = useTranslation();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const navigate = useNavigate();
  const { search } = useLocation();
  return useMutation({
    mutationFn: resetPwdAuthApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          onSetAlert({
            isOpen: true,
            inner: t("alt_auth_eml_verified"),
            onSetConfirm: () => {
              navigate("/resetPwd/reset", {
                state: {
                  certEncParam: search.replace("?param=", ""),
                },
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
